@use "foundation/_colors.scss";

// Tooltip styles for react component
.hover-area {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
}

.tool-tip {
  position: absolute;
  left: -1000px;
  top: -1000px;
  width: 14em;
  color: colors.$secondary-text-color;
  font-size: 0.444444em; // 16px
  font-weight: 500;
  line-height: 1.2em;
  white-space: pre-wrap;
  background-color: colors.$secondary-background-color;
  border: 1px solid colors.$tertiary-background-color;
  border-radius: 5px;
  padding: 6px;
  box-shadow: 0 1.5px 6px 0 rgba(0, 0, 0, 0.24);
  z-index: 10;
  cursor: auto;
}

// CSS hover-based tooltip
.tooltip-container {
  position: relative;
}

.tooltip-container [data-has-tooltip="true"] {
  position: relative;
}

.tooltip-container .tool-tip {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  left: calc(100%);
  top: 0;
  transition: opacity 0.3s, visibility 0s linear 0.3s;
  pointer-events: none;
  z-index: 2;
}

.tooltip-container:hover .tool-tip {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.3s 0.5s, visibility 0s linear 0.5s;
}

.tool-tip--dark {
  width: 305px;
  max-width: 305px;
  background-color: colors.$neutrals-darker-grey;
  color: colors.$neutrals-light-grey;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  padding: 16px;
  border-radius: 10px;
  border: none;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
  word-wrap: break-word;
}
